import CreatorsRoutes from "./pages/creators.routes";
import LicenseesRoutes from "./pages/licensees.routes";
import AdminRoutes from "./pages/admin.routes";
import SafRoutes from "./pages/saf.routes";
import FixiterRoutes from "./pages/fixiter.routes";
import OpenPagesRoutes from "./pages/openPages.routes";
import EmployeeRoutes from "./pages/employee.routes";
import { Fragment } from "react";
import AuthGuard from "./AuthGuard";
import { PrinterProvider } from "../hooks/PrintersContext";
import { OnboardProvider } from "../hooks/OnboardContext";
import { TipsProvider } from "../hooks/TipsContext";
import { WebSocketProvider } from "../hooks/PrinterWebSocketContext";
import { FinancialStatusProvider } from "../hooks/FinancialStatusContext";

function Router() {
  return (
    <Fragment>
      <OpenPagesRoutes />
      <AuthGuard>
        <WebSocketProvider>
          <TipsProvider>
            <PrinterProvider>
              <OnboardProvider>
                <FinancialStatusProvider>
                  <Fragment>
                    <AdminRoutes />
                    <CreatorsRoutes />
                    <FixiterRoutes />
                    <LicenseesRoutes />
                    <SafRoutes />
                    <EmployeeRoutes />
                  </Fragment>
                </FinancialStatusProvider>
              </OnboardProvider>
            </PrinterProvider>
          </TipsProvider>
        </WebSocketProvider>
      </AuthGuard>
    </Fragment>
  );
}

export default Router;
